module.exports = __webpack_public_path__ + "img/folder-open-outlined.f158b3ea.svg";